import Icon from 'veui/components/Icon'

Icon.register({
  'chevron-double-up': {
    raw: '<g fill="none" fill-rule="evenodd"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M44 24L24 4 4 24"/><path d="M44 43L24 23 4 43"/></g><path d="M2.59 25.41a2 2 0 002.82 0L24 6.83 42.59 25.4a2 2 0 002.82-2.82l-20-20a2 2 0 00-2.82 0l-20 20a2 2 0 000 2.82zm0 19a2 2 0 002.82 0L24 25.83 42.59 44.4a2 2 0 002.82-2.82l-20-20a2 2 0 00-2.82 0l-20 20a2 2 0 000 2.82z" fill="currentColor" fill-rule="nonzero"/></g>',
    width: '48',
    height: '48'
  }
})
